var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDoubt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33333 8.00004C1.33333 4.05723 4.55719 0.833374 8.5 0.833374C12.4428 0.833374 15.6667 4.05723 15.6667 8.00004C15.6667 11.9428 12.4428 15.1667 8.5 15.1667C4.55719 15.1667 1.33333 11.9428 1.33333 8.00004ZM8.5 1.83337C5.10948 1.83337 2.33333 4.60952 2.33333 8.00004C2.33333 11.3906 5.10948 14.1667 8.5 14.1667C11.8905 14.1667 14.6667 11.3906 14.6667 8.00004C14.6667 4.60952 11.8905 1.83337 8.5 1.83337Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27778 9.81327C8.64578 9.81327 8.94444 10.0866 8.94444 10.4233C8.94444 10.7601 8.64578 11.0334 8.27778 11.0334C7.90978 11.0334 7.61111 10.7601 7.61111 10.4233C7.61111 10.0866 7.90978 9.81327 8.27778 9.81327ZM8.72222 8.99986C8.72222 8.7717 8.90356 8.50165 9.13467 8.38493C9.80133 8.04859 10.16 7.35882 10.0276 6.66784C9.90178 6.01142 9.31289 5.47294 8.596 5.35825C8.07244 5.27488 7.53867 5.40299 7.13511 5.71331C6.73156 6.02362 6.5 6.4775 6.5 6.95944C6.5 7.18394 6.69911 7.36614 6.94444 7.36614C7.18978 7.36614 7.38889 7.18394 7.38889 6.95944C7.38889 6.71867 7.50489 6.49133 7.70667 6.33597C7.91156 6.17817 8.17289 6.11553 8.44267 6.15905C8.79244 6.21518 9.09067 6.48807 9.152 6.80815C9.22 7.16198 9.04489 7.50117 8.70578 7.67239C8.192 7.93146 7.83333 8.47725 7.83333 8.99986C7.83333 9.22477 8.03244 9.40657 8.27778 9.40657C8.52311 9.40657 8.72222 9.22477 8.72222 8.99986Z",
    fill: "#004853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoubt);
export default __webpack_public_path__ + "static/media/icon_doubt.8e1b95a1c3db3933d32412e8dbbc2339.svg";
export { ForwardRef as ReactComponent };